export default __webpack_public_path__ + "static/media/hr_logo.83c623fe.png";